import React, { useEffect, useState } from "react";
import "./Competitions.scss";
import Button from "../../reusable/Button/Button";
import { ReactComponent as ArrowRight } from "../../../../../assets/icons/svg/arrow-right.svg";
import { useHistory } from "react-router-dom";
import axios from "axios";
import Loader from "react-loader-spinner";

export default function Competitions(props) {
  const history = useHistory();

  const [competitions, setCompetitions] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`site/get_competitions?id_club=${props.id_club}`)
      .then((res) => {
        setCompetitions(res.data);
        setLoaded(true);
      })
      .catch((err) => console.log(err));
  }, []);

  const coaches = [
    { key: 1, name: "Narcis Badic" },
    { key: 2, name: "Alin Lungu" },
    { key: 3, name: "Dan Savin" },
  ];

  return (
    <div className="competitions-container-3">
      <div
        className="competitions-title"
        style={{ color: props.config_options.section_title_color }}
      >
        Competiții
      </div>
      {!loaded ? (
        <div className="loader-container">
          <Loader
            type="ThreeDots"
            color={props.config_options.main_color}
            height={80}
            width={80}
          />
        </div>
      ) : (
        <div className="competitions-list">
          {competitions.map((item) => {
            return (
              <div
                className="competition-card"
                key={item.id_competition}
                style={{
                  borderColor: "white",
                  borderRadius: 30,
                }}
              >
                <div
                  className="competition-name notranslate"
                  style={{ color: props.config_options.groups_name_color }}
                >
                  {item.competition_name}
                </div>
                <div
                  className="competition-group"
                  style={{ color: props.config_options.groups_name_color }}
                >
                  <span style={{ color: "#01b1e4", paddingRight: 5 }}>
                    Grupa:{" "}
                  </span>
                  {item.category}
                </div>
                <div
                  className="competition-coach"
                  style={{ color: props.config_options.groups_coach_color }}
                >
                  <div>
                    <div className="coach" style={{ color: "#01b1e4" }}>
                      Antrenori:
                    </div>
                    {coaches.map((item) => {
                      return (
                        <div className="coach-name notranslate" key={item.key}>
                          {item.name}
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="competition-more-button">
                  <button
                    className="competition-button"
                    onClick={() => {
                      history.push(
                        `/competitions/${item.competition_name
                          .toLowerCase()
                          .normalize("NFD")
                          .replace(/[\u0300-\u036f]/g, "")
                          .replace(/[^a-zA-Z0-9 \-]/g, "")
                          .replaceAll(" ", "-")}-${item.id_competition}`
                      );
                    }}
                    theme={props.config_options.id_theme}
                    color={props.config_options.buttons_text_color}
                    backgroundColor={props.config_options.buttons_color}
                  >
                    Vezi rezultate{" "}
                    {/* <ArrowRight
                      fill={props.config_options.buttons_text_color}
                      className="discover-more-button-icon"
                    /> */}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
